module.exports = __webpack_public_path__ + "static/media/law.7cf67376.png";